var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24TubeFlourescentLuminaire01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 2.38,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 2.06,
    className: "st2",
    width: 0.5,
    height: 1.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 2.06,
    className: "st2",
    width: 0.5,
    height: 1.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 4.05,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 3.18,
    className: "st2",
    width: 0.5,
    height: 1.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 3.18,
    className: "st2",
    width: 0.5,
    height: 1.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 7.59,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 7.27,
    className: "st2",
    width: 0.5,
    height: 1.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 7.27,
    className: "st2",
    width: 0.5,
    height: 1.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 9.27,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 8.39,
    className: "st2",
    width: 0.5,
    height: 1.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 8.39,
    className: "st2",
    width: 0.5,
    height: 1.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 11.21,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 9.99,
    className: "st2",
    width: 0.5,
    height: 2.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 9.99,
    className: "st2",
    width: 0.5,
    height: 2.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 12.89,
    className: "st2",
    width: 11.73,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 12.01,
    className: "st2",
    width: 0.5,
    height: 1.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 12.01,
    className: "st2",
    width: 0.5,
    height: 1.93
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24TubeFlourescentLuminaire01);
export default __webpack_public_path__ + "static/media/24TubeFlourescentLuminaire-01.3fb9fd744c86965632c44dd9f7e21ce1.svg";
export { ForwardRef as ReactComponent };